export const DYNAMIC_QUEUE_CONSTANTS = {
  OBJECT: 'object',
  ACTION: 'action',
  ONLINE: 'online',
  SUBSCRIBE: 'subscribe',
  X_TENANT_ID: 'x-tenantId',
  AGENT_AVAILABILITY: 'AgentAvailability',
  AUTH_CLIENT: 'auth_client',
  SELECT: 'Select',
  AVAILABLE_AGENTS: 'Available Agents',
  ASSIGN_TO_AGENTS: 'Assign To Agent',
  ASSIGN_TO_ME: 'Assign To Me',
  CANCEL: 'Cancel',
  ASSIGN: 'Assign',
  ASSIGNED: 'Assigned',
  CASE_LOWERCASE: 'case',
  WEB_LOWERCASE: 'web',
  INTAKE_LOWERCASE: 'intake',
  MY_TASK_LOWERCASE: 'my_task',
  INTAKE_UPPERCASE: 'Intake Queue',
  HYPERLINK: 'hyperlink',
  CASE_UPPERCASE: 'Case',
  UNASSIGN: 'Unassign',
  UNASSIGNED: 'Unassigned',
  COMPONENT: 'component',
  REVIEW: 'review',
  SELECTED: 'selected',
  SEARCH_AGENTS: 'Search agents...',
  SEARCH: 'Search',
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Unavailable',
  ID: 'id',
  CHECKBOX: 'checkbox',
  COMMUNICATIONS_LOWERCASE: 'communication',
  DISCARDED_LOWERCASE: 'discarded',
  FAILED_LOWERCASE: 'failed',
  COMPLETED: 'Completed',
  INTAKE_ID: 'intake_id',
  CASE_ID: 'case_id',
  ACTIONS: 'Actions',
  DOCUMENT_ID: 'document_id',
  DOCUMENT: 'document',
  CASE_KEY: 'case_key',
  COMMUNICATION_ID: 'communication_id',
  RECORD: 'record',
  CONFIRM: 'Confirm',
  PRONOUN_IT: 'it',
  PRONOUN_THEM: 'them',
  VERB_IS: 'is',
  VERB_ARE: 'are',
  CONFIRMATION_REASSIGNMENT_TYPE: 'CONFIRMATION_REASSIGNMENT',
  REASSIGNMENT_SOURCE_QUEUE_AGENT: 'queueAgent',
  REASSIGNMENT_SOURCE_CASE: 'case',
  REASSIGNMENT_SOURCE_WEB_ENTITY: 'hcp_portal_entity',
  REASSIGNMENT_CANCEL_QA_ID: 'reassignment-confirm-cancel',
  REASSIGNMENT_CONFIRM_QA_ID: 'reassignment-confirm-yes',
  ENROLLMENT_ID: 'enrollment_id',
  DOCUMENT_KEY: 'documents.document_key',
}

export const DYNAMIC_QUEUE_MESSAGES = {
  ASSIGN_LETTER_TO_AGENT: 'Letter/s successfully assigned to ',
  ASSIGN_CASE_TO_AGENT: 'Case/s successfully assigned to ',
  ASSIGN_INTAKE_TO_AGENT: 'Intake/s successfully assigned to ',
  VALIDATE_CASES_WITH_AGENT: 'Cases validated successfully.',
  ERROR_VALIDATE_CASE_WITH_AGENT:
    'Agent not assigned to this program. Please select another agent',
  NO_CASE_AVAILABLE: 'No case available to be assigned',
  UNASSIGNED_SUCCESSFULLY: 'Agent/s unassigned successfully.',
  ASSIGNED_SUCCESSFULLY: 'Agent/s assigned successfully.',
  BULK_UNASSIGNED_SUCCESS_CASE: 'Successfully unassigned the selected cases.',
  BULK_UNASSIGNED_ERROR_CASE:
    'Unable to unassign some cases. Please try again.',
  BULK_UNASSIGNED_SUCCESS_INTAKE:
    'Successfully unassigned the selected intakes.',
  BULK_UNASSIGNED_ERROR_INTAKE:
    'Unable to unassign some intakes. Please try again.',
  ERROR_WHILE_ASSIGNING: 'Error occured while assigning.',
  ERROR_WHILE_UNASSIGNING: 'Error occured while unassigning',
  CONFIRMATION_UNASSIGN_MESSAGE: 'Do you want to unassign this agent?',
  CONFIRMATION_BULK_UNASSIGN_MESSAGE:
    'Are you sure you want to unassign the selected cases?',
  CONFIRMATION_BULK_UNASSIGN_INTAKE_MESSAGE:
    'Are you sure you want to unassign the selected intakes?',
  CONFIRMATION_REASSIGNMENT:
    'This record is already assigned to an agent. Are you sure you want to reassign it to a new agent?',
  CONFIRMATION_CASE_REASSIGNMENT:
    'This case is already assigned to an agent. Are you sure you want to reassign it to a new agent?',
  ATTENTION_REQUIRED: 'Attention Required!',
  ALREADY_ASSIGNED_TO_AGENT: 'already assigned to an agent.',
  REASSIGN_CONFIRM_QUESTION:
    'Are you sure you want to reassign {pronoun} to a new agent?',
  UNASSIGN_TOOLTIP_MESSAGE: 'Unassign agents from the queue',
  ASSIGN_ATLEAST_ONE_AGENT: 'Please select at least one agent',
  ASSIGN_ATLEAST_ONE_CASE: 'Please select at least one case',
  NEW_CASE_MESSAGE:
    'Please search from below and attach case or Click on create new case button to make a new case',
  EMPTY_TABLE_QUEUE_MESSAGE:
    'Existing cases do not match the search criteria. Please create a New Case',
  REVIEW_TOOLTIP_MESSAGE: 'Review',
  ASSIGNED_NEW_WORK: 'You have been assigned a new',
  CASE_ALREADY_ASSIGNED: 'The case has already been assigned to another agent',
  CASE_UNAVAILABLE: 'No case available for assignment',
  INTAKE_UNAVAILABLE: 'No intake available for assignment',
  FAX_ID: 'Fax ID',
  MAIL_ID: 'Mail ID',
  NO_PERMISSIONS_MESSAGE:
    'You do not have permission to attach the intake to an existing or new case.',
  No_PERMISSION_SUBTEXT: 'Please contact the admin if there is an issue.',
  LETTER_ID: 'Letter ID',
  ERROR_MESSAGE: 'An unexpected error occurred',
  NO_LAYOUT_MESSAGE: 'No layouts for this entity found.',
  ROWS_SELECTED: 'rows selected',
  ROW_SELECTED: 'row selected',
  QUEUE_REFRESH_ERROR: 'Unable to refresh queue data. Please try again.',
}
export enum PRINT_MAIL_ACTIONS_ENUM {
  DISCARDED = 'DISCARDED',
  COMPLETED = 'COMPLETED',
  VOIDED = 'VOID',
  PRINT = 'PRINT',
}

export const PRINT_MAIL_ACTIONS = [
  { label: 'Print', value: PRINT_MAIL_ACTIONS_ENUM.PRINT, key: 'print' },
  {
    label: 'Complete',
    value: PRINT_MAIL_ACTIONS_ENUM.COMPLETED,
    key: 'completed',
  },
  {
    label: 'Discard',
    value: PRINT_MAIL_ACTIONS_ENUM.DISCARDED,
    key: 'discard',
  },
  { label: 'Void', value: PRINT_MAIL_ACTIONS_ENUM.VOIDED, key: 'void' },
]
